import React from 'react';
import { useTranslation } from 'react-i18next';
import PageHeader from '../../components/common/PageHeader';

const AboutUs = () => {
  const { t } = useTranslation();
  const sections = t('legal.about.sections', { returnObjects: true });

  return (
    <div className="min-h-screen bg-primary-50 pb-12">
      <PageHeader title={t('legal.about.title')} subtitle={t('legal.about.subtitle')} />

      <div className="max-w-4xl mx-auto px-4">
        <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6 md:p-8 mb-8">
          <p className="text-gray-700 leading-relaxed">{t('legal.about.intro')}</p>
        </div>

        {Array.isArray(sections) && sections.length > 0 && (
          <div className="space-y-6">
            {sections.map((section, idx) => (
              <div
                key={idx}
                className="bg-white rounded-xl shadow-sm border border-gray-100 p-6 md:p-8"
              >
                <h2 className="text-lg md:text-xl font-bold text-gray-900 mb-4">
                  {section.title}
                </h2>
                {Array.isArray(section.paragraphs) && section.paragraphs.length > 0 && (
                  <div className="space-y-3 mb-4">
                    {section.paragraphs.map((p, pIdx) => (
                      <p key={pIdx} className="text-gray-700 leading-relaxed">
                        {p}
                      </p>
                    ))}
                  </div>
                )}
                {Array.isArray(section.bullets) && section.bullets.length > 0 && (
                  <ul className="space-y-2">
                    {section.bullets.map((b, bIdx) => (
                      <li key={bIdx} className="flex items-start gap-3">
                        <span className="mt-2 w-1.5 h-1.5 rounded-full bg-primary-500 flex-shrink-0" />
                        <span className="text-gray-700">{b}</span>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            ))}
          </div>
        )}

        <div className="bg-gradient-to-br from-primary-50 to-blue-50 rounded-xl border border-primary-100 p-6 md:p-8 mt-8">
          <h2 className="text-lg md:text-xl font-bold text-gray-900 mb-3">
            {t('legal.about.contact.title')}
          </h2>
          <p className="text-gray-700 mb-3">{t('legal.about.contact.text')}</p>
          <a
            href={`mailto:${t('legal.about.contact.email')}`}
            className="text-primary-600 font-semibold hover:text-primary-700 transition"
          >
            {t('legal.about.contact.email')}
          </a>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
